// cQuery
const $$ = document.querySelectorAll.bind(document);
const $1 = document.querySelector.bind(document);

const btnPinnedDark = "theme--reversePickle"
const btnScrolled = "theme--grapefruit"

window.HiSnaps = {

    // Theme settings bridged from Liquid (see snippets/promo-config.liquid).
    // Shape: { hiddenSizes: [], promo: { enabled, preview, active, start, end, subscriptions, previewCode, offers: {...} } }
    config: window.HiSnapsConfig || { hiddenSizes: [], promo: { active: false, offers: {} } },

    formatCompact(n, { roundDown = false } = {}) {
        n = parseInt(n, 10);
        if (isNaN(n)) return n;
        if (n >= 1000) {
            const val = roundDown ? Math.floor(n / 100) / 10 : n / 1000;
            return val.toFixed(1).replace(/\.0$/, '') + 'k';
        }
        return String(n);
    },
    formatNumber(n) {
        n = parseInt(n, 10);
        if (isNaN(n)) return n;
        return n.toLocaleString('en-US');
    },

    reviewsApi: {
        base: 'https://reviews.hisnaps.com/api',

        async get(path, params = {}) {
            const url = new URL(`${this.base}${path}`);
            Object.entries(params).forEach(([k, v]) => {
                if (v != null) url.searchParams.set(k, String(v));
            });
            const res = await fetch(url, { mode: 'cors' });
            if (!res.ok) throw new Error(`Reviews API ${res.status}: ${path}`);
            return res.json();
        },

        async submit(data) {
            const res = await fetch(`${this.base}/reviews/submit`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
                mode: 'cors',
            });
            const json = await res.json();
            if (!res.ok) throw new Error(json.error || 'Submission failed');
            return json;
        },
    },

    mobileBreakpoint: 1000,
    nav: $1("header.nav"),
    navScrollMax: 2,
    navWrap: $1("header.nav > .wrap"),
    menuBtn: $1("header.nav .menu-btn"),
    cartBtn: $1("header.nav .open-cart"),
    isNavTrans: false,
    showingMenu: false,
    announceBar: $1(".announcement-bar"),

    initNavPin() {
        // Have to use raw scroll listener here instead of observer, because Mobile Safari
        // is a sassy minx who behaves very naughty when there's overscroll.
        let lastScrollY = window.scrollY;
        let ticking = false;
        let isPinned = false;
        
        const updateNav = () => {
            const scrollY = window.scrollY;
            const shouldPin = scrollY > this.navScrollMax;
            if (shouldPin === isPinned) {
                ticking = false;
                return;
            }
            
            isPinned = shouldPin;
            
            if (isPinned) {
                if (this.isNavTrans && !this.showingMenu) {
                    this.cartBtn?.classList.remove(btnPinnedDark);
                    this.cartBtn?.classList.add(btnScrolled);
                }
                this.nav?.classList.add("pinned");
            } else {
                if (this.isNavTrans && !this.showingMenu) {
                    this.cartBtn?.classList.remove(btnScrolled);
                    this.cartBtn?.classList.add(btnPinnedDark);
                }
                this.nav?.classList.remove("pinned");
            }
    
            ticking = false;
        };
    
        const onScroll = () => {
            lastScrollY = window.scrollY;
            
            if (!ticking) {
                requestAnimationFrame(updateNav);
                ticking = true;
            }
        };
    
        window.addEventListener('scroll', onScroll, { passive: true });
        
        // Store for cleanup, if needed.
        this.scrollHandler = onScroll;
    },
    
    initNavMobileMenu() {
        const menuItems = $$('header.nav .mobile-menu .menu-label, header.nav .mobile-menu .menu-group > a, header.nav .mobile-menu .social, header.nav .mobile-menu .menu-footer');
        menuItems.forEach((item, index) => {
            item.style.setProperty('--stagger-index', index);
        });

        this.menuBtn?.addEventListener("click", (e) => {
            e.preventDefault();
            
            this.showingMenu = !this.showingMenu;
            const isPinned = this.nav?.classList.contains("pinned");

            if (this.showingMenu) {
                $1("html").classList.add("show-menu", "no-scroll");
                if (this.isNavTrans) {
                    this.cartBtn?.classList.remove(btnPinnedDark);
                    this.cartBtn?.classList.add(btnScrolled);
                }
            } else {
                $1("html").classList.remove("show-menu", "no-scroll");
                if (this.isNavTrans && !isPinned) {
                    this.cartBtn?.classList.remove(btnScrolled);
                    this.cartBtn?.classList.add(btnPinnedDark);
                }
            }
        });
    },
    clearMobileNav() {
        const isPinned = this.nav?.classList.contains("pinned");

        this.showingMenu = false;

        $1("html").classList.remove("show-menu", "no-scroll");
        if (this.isNavTrans) {
            if (isPinned) {
                this.cartBtn?.classList.remove(btnPinnedDark);
                this.cartBtn?.classList.add(btnScrolled);
            } else {
                this.cartBtn?.classList.remove(btnScrolled);
                this.cartBtn?.classList.add(btnPinnedDark);
            }
        }
    },

    // Desktop shop panel: hover the Shop link to open, hover a collection name to
    // switch tiles, leave to close (with a little grace so crossing the gap between
    // the bar and the panel doesn't flicker it shut).
    initShopPanel() {
        const panel = $1("header.nav .shop-panel");
        const trigger = $1("header.nav .shop-link");
        if (!panel || !trigger || !this.nav) return;

        const collectionLinks = panel.querySelectorAll(".panel-collections a[data-handle]");
        const tileGroups = panel.querySelectorAll(".tile-group");
        const defaultHandle = collectionLinks[0]?.dataset.handle || panel.dataset.active;
        let closeTimer = null;

        const setActive = (handle) => {
            panel.dataset.active = handle;
            collectionLinks.forEach(l => l.classList.toggle("active", l.dataset.handle === handle));
            tileGroups.forEach(g => g.classList.toggle("active", g.dataset.handle === handle));
        };
        setActive(defaultHandle);

        // On the transparent (homepage) header the bar gains its light background
        // while open, so the cart button swaps to the theme it wears when pinned.
        const syncCartBtn = (opening) => {
            if (!this.isNavTrans || this.nav.classList.contains("pinned")) return;
            this.cartBtn?.classList.toggle(btnPinnedDark, !opening);
            this.cartBtn?.classList.toggle(btnScrolled, opening);
        };
        const open = () => {
            clearTimeout(closeTimer);
            if (!this.nav.classList.contains("show-shop")) {
                setActive(defaultHandle);
                syncCartBtn(true);
            }
            this.nav.classList.add("show-shop");
        };
        const hide = () => {
            if (!this.nav.classList.contains("show-shop")) return;
            this.nav.classList.remove("show-shop");
            syncCartBtn(false);
        };
        const close = (immediate = false) => {
            clearTimeout(closeTimer);
            if (immediate) { hide(); return; }
            closeTimer = setTimeout(hide, 180);
        };

        trigger.addEventListener("mouseenter", open);
        trigger.addEventListener("mouseleave", () => close());
        panel.addEventListener("mouseenter", open);
        panel.addEventListener("mouseleave", () => close());

        // Touch at desktop width: first tap opens, second tap follows the link.
        trigger.addEventListener("click", (e) => {
            if (window.matchMedia("(hover: none)").matches && !this.nav.classList.contains("show-shop")) {
                e.preventDefault();
                open();
            }
        });

        // Keyboard: focus opens, tabbing out closes, Escape closes.
        trigger.addEventListener("focus", open);
        panel.addEventListener("focusout", (e) => {
            if (!panel.contains(e.relatedTarget) && e.relatedTarget !== trigger) close();
        });
        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape") close(true);
        });

        collectionLinks.forEach(link => {
            const activate = () => setActive(link.dataset.handle);
            link.addEventListener("mouseenter", activate);
            link.addEventListener("focus", activate);
        });
    },

    initNavLinks() {
        const productLink = $1(".product-link");
        const vibesLink = $1(".vibes-link");

        if (productLink) {
            productLink.addEventListener("click", (e) => {
                e.preventDefault();

                $1("html").classList.remove("show-menu", "no-scroll");
                
                const introSection = $1("section.intro")
                if (introSection) {
                    introSection.scrollIntoView({ behavior: 'smooth' });
                } else {
                    const howToSection = $1("section.howImages")
                    if (howToSection) {
                        howToSection.scrollIntoView({ behavior: 'smooth' });
                    } else {
                        const gif = $1(".snap-gif")
                        if (gif) {
                            gif.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        } else {
                            window.location = "/?t=vibes";
                        }
                    }
                }
            });
        }

        if (vibesLink) {
            vibesLink.addEventListener("click", (e) => {
                e.preventDefault();

                $1("html").classList.remove("show-menu", "no-scroll");

                const vibesSection = $1("section.vibes")
                if (vibesSection) {
                    vibesSection.scrollIntoView({ behavior: 'smooth' });
                } else {
                    const howToSection = $1("section.howImages")
                    if (howToSection) {
                        howToSection.scrollIntoView({ behavior: 'smooth' });
                    } else {
                        window.location = "/?t=vibes";
                    }
                }
            });
        }
    },

    initFixedCalcs() {
        const body = $1("body");
        const footer = $1(".footer");
        const mainPage = $1("#main-page");
        if (!mainPage || !footer || !this.nav) return;

        const updateNavHeight = () => {
            // Set nav height.
            // this.nav.style.height = `${ Math.ceil(this.nav.clientHeight) }px`;
            // console.log( Math.ceil(this.nav.clientHeight) );

            // And check if we have an announcement bar and it's showing.
            // If so, store/update the height in a CSS var on mast (if it's homepage), and also use that value as our scroll max.
            if (this.announceBar && body.classList.contains("has-announcement")) {
                this.navScrollMax = Math.ceil(this.announceBar.clientHeight);
                body.setAttribute("style", `--announcementClearance: ${this.navScrollMax}px;`);
            }
        };
        updateNavHeight();
        
        // Set footer clearance size.
        const updateFooterMargin = () => {
            mainPage.style.marginBottom = `${Math.ceil(footer.clientHeight) + 1}px`;
        };
        updateFooterMargin();
        
        // Listen for size changes.
        const observer = new ResizeObserver(() => {
            updateNavHeight();
            updateFooterMargin();
            
            if (window.innerWidth > this.mobileBreakpoint && this.showingMenu) {
                this.clearMobileNav()
            }
        });
        observer.observe(footer);
        
        // Store observer for cleanup, if needed.
        this.resizeObserver = observer;
    },

    initAccordions() {
        const accordions = $$(".accordion");
        if (!accordions) return;
        if (accordions.count == 0) return;
        
        const showClass = "show";

        accordions.forEach(accordion => {
            const items = accordion.querySelectorAll(".item:not(.link)");
            items.forEach(item => {
                const trigger = item.querySelector("dt");
                if (!trigger) return;

                trigger.addEventListener("click", (e) => {
                    e.preventDefault();
    
                    if (item.classList.contains(showClass)) {
                        item.classList.remove(showClass);
                        return;
                    }
    
                    items.forEach(item => {
                        item.classList.remove(showClass);
                    })
                    item.classList.add(showClass);
                });
            });

            // Wire up hide/show target, if available.
            const target = accordion.getAttribute("data-more-target");
            if (!target) return;
            const hideShowBtn = $1(`.btn[data-more-target="${target}"]`);
            if (!hideShowBtn) return;
            hideShowBtn.addEventListener("click", (e) => {
                e.preventDefault();
                
                if (accordion.classList.contains("show-all")) {
                    accordion.classList.remove("show-all");
                    hideShowBtn.classList.remove("arrow-up");
                } else {
                    accordion.classList.add("show-all");
                    hideShowBtn.classList.add("arrow-up");
                }
            });
        });
    },

    initTicker(el) {
        if (!el) return;
        const text = el.innerHTML.trim();
        if (!text) return;

        const alwaysScroll = el.dataset.ticker === "always";
        const separator   = el.dataset.tickerSeparator ?? null;
        const gap         = el.dataset.tickerGap ?? null;
        const speed       = el.dataset.tickerSpeed ?? null;
        const noPause     = "tickerNoPause" in el.dataset;
        let marqueeTimeout;

        if (noPause) el.classList.add("no-pause");
        if (gap != null) { el.style.setProperty("--ticker-gap", gap); el.style.setProperty("--ticker-gap-start", "0"); }
        if (speed != null) el.style.setProperty("--ticker-speed", speed);

        const buildMarquee = () => {
            el.textContent = "";
            if (separator != null) el.classList.add("has-separator");
            for (let i = 0; i < 5; i++) {
                const copy = document.createElement("div");
                copy.style.cssText = "flex-shrink:0;white-space:nowrap;";
                copy.innerHTML = separator != null ? text + separator : text;
                if (i > 0) copy.setAttribute("aria-hidden", "true");
                el.appendChild(copy);
            }
            clearTimeout(marqueeTimeout);
            marqueeTimeout = setTimeout(() => {
                el.classList.add("will-marquee", "needs-marquee");
            }, 120);
        };

        const buildStatic = () => {
            clearTimeout(marqueeTimeout);
            el.innerHTML = `<div>${text}</div>`;
            el.classList.remove("will-marquee", "needs-marquee");
            marqueeTimeout = setTimeout(() => el.classList.add("no-marquee"), 120);
        };

        const check = () => {
            if (alwaysScroll) { buildMarquee(); return; }

            const contentEl = el.firstElementChild || el;
            const style = getComputedStyle(contentEl);
            const temp = document.createElement("span");
            temp.style.cssText = "position:absolute;visibility:hidden;white-space:nowrap;pointer-events:none;";
            temp.style.fontSize = style.fontSize;
            temp.style.fontFamily = style.fontFamily;
            temp.style.fontWeight = style.fontWeight;
            temp.style.letterSpacing = style.letterSpacing;
            temp.textContent = el.textContent.trim();
            document.body.appendChild(temp);
            const textWidth = temp.offsetWidth;
            document.body.removeChild(temp);

            const elStyle = getComputedStyle(el);
            const availableWidth = el.clientWidth - parseFloat(elStyle.paddingLeft) - parseFloat(elStyle.paddingRight);
            if (textWidth > availableWidth) buildMarquee();
            else buildStatic();
        };

        check();

        // Resize only matters for conditional tickers (always-scroll never switches back).
        if (!alwaysScroll) {
            let resizeTimer;
            window.addEventListener("resize", () => {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(check, 250);
            });
        }
    },

    initAnnouncement() {
        this.initTicker(this.announceBar);
    },

    initTickers() {
        $$(".ticker:not(.announcement-bar)").forEach(el => this.initTicker(el));
    },

    confettiMe(el) {
        let x = 0.5;
        let y = 0.62;
        if (el) {
            const rect = el.getBoundingClientRect();
            x = (rect.left + rect.width / 2) / window.innerWidth;
            y = (rect.top + rect.height / 2) / window.innerHeight;
        }

        const isMobile = window.innerWidth < this.mobileBreakpoint;
        const velocityMultiplier = (isMobile) ? 0.42 : 1;
        const spreadMultiplier = (isMobile) ? 1.2 : 1;

        const defaults = {
            angle: (isMobile) ? 142 : 192,
            origin: { x: x, y: y },
            colors: [ "#3E571B", "#E2F878", "#F6B176", "#F48672", "#753251", "#7389AE" ]
        };

        function fire(particleRatio, opts) {
            confetti({
                ...defaults,
                ...opts,
                particleCount: Math.floor(420 * particleRatio)
            });
        }
        
        fire(0.24, {
            spread: 26 * spreadMultiplier,
            startVelocity: 57 * velocityMultiplier,
        });
        fire(0.21, {
            spread: 69 * spreadMultiplier,
        });
        fire(0.34, {
            spread: 134 * spreadMultiplier,
            decay: 0.81,
            scalar: 0.84
        });
        fire(0.12, {
            spread: 120 * spreadMultiplier,
            startVelocity: 34 * velocityMultiplier,
            decay: 0.93,
            scalar: 1.2
        });
        fire(0.12, {
            spread: 120 * spreadMultiplier,
            startVelocity: 48 * velocityMultiplier,
        });    
    },

    checkUrlParams() {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get("cart")) {
            requestAnimationFrame(() => {
                if (this.cart) this.cart.showCart(true);
            });
        }
        if (urlParams.get("t")) {
            requestAnimationFrame(() => {
                if (urlParams.get("t") === "reviews") {
                    const reviewsSection = $1("#user-reviews");
                    if (reviewsSection) {
                        // Post-purchase review emails land here: open the form so
                        // the customer doesn't have to find the button first.
                        this.reviews?.showForm(true);
                        reviewsSection.scrollIntoView({ behavior: "smooth" });
                    }
                } else {
                    const howToSection = $1("section.howImages")
                    if (howToSection) {
                        howToSection.scrollIntoView({ behavior: "smooth" });
                    } else {
                        const gif = $1(".snap-gif")
                        if (gif) gif.scrollIntoView({ behavior: "smooth", block: "center" });
                    }
                }
            });
        }
    },

    initSnapGif() {
        const snapGif = $1(".snap-gif .gifs .gif");
        if (!snapGif) { return }

        const images = snapGif.querySelectorAll("img");
        if (images.length !== 3) { return }

        // Animation sequence: start at 2 (index 1), go to 3 (index 2), 
        // back to 2, then to 1 (index 0), back to 2, repeat
        const sequence = [1, 2, 1, 0]; // indices of images to show
        let currentStep = 0;

        const animate = () => {
            // Remove active from all images
            images.forEach(img => img.classList.remove("active"));
            
            // Add active to current image in sequence
            images[sequence[currentStep]].classList.add("active");
            
            // Move to next step in sequence
            currentStep = (currentStep + 1) % sequence.length;
        };

        // Start the animation loop (500ms = 0.5 seconds)
        setInterval(animate, 500);
    },

    initRatingRecaps() {
        $$(".rating-recap[data-rating]").forEach(el => {
            setTimeout(() => {
                el.style.setProperty("--starRating", el.dataset.rating);
            }, 420);
        });
    },

    // Main Init
    snapIt() {
        console.log("HiSnaps Nerds, reporting for duty!");

        // Nav
        this.isNavTrans = this.navWrap?.classList.contains("trans");
        this.initFixedCalcs();
        this.initNavPin();
        this.initNavMobileMenu();
        this.initNavLinks();
        this.initShopPanel();

        // Global Modules
        if (this.cart) this.cart.init();

        // NOTE: Make sure cart is first, so we have access to product data
        //       downstream wherever we might need it (reviews, etc).
        //       Cart is also responsible for any A/B test attributions.

        if (this.reviews) this.reviews.init();
        if (this.footerEmail) this.footerEmail.init();
        if (this.contestEmail) this.contestEmail.init();

        // Modal Sequence — register every page-load modal, then let the
        // orchestrator decide what shows and in what order (see scripts.modals.js).
        if (this.modals) {
            if (this.ageGate) this.ageGate.register();
            if (this.emailModal) this.emailModal.register();
            if (this.welcomePopup) this.welcomePopup.register();
            this.modals.start();
        }
        
        // Handle /cart redirect, and any other URL param stuff.
        this.checkUrlParams();
        
        // In-page Modules
        this.initAccordions();
        this.initAnnouncement();
        this.initTickers();
        this.initSnapGif();
        if (this.carousels) this.carousels.init();
        if (this.press) this.press.init();
        if (this.featuredReviews) this.featuredReviews.init();
        if (this.autoRotate) this.autoRotate.init();
        if (this.galleries) this.galleries.init();
        this.initRatingRecaps();

        // Page-Specific Modules
        if (this.home && $1("body").classList.contains("page-home")) {
            this.home.initScrollEffects();
            this.home.initButtons();
        }

        // If the user navigates away while a button is loading (e.g. checkout) and
        // then hits back, the browser may restore the page from bfcache with loading
        // classes still applied. Strip them on any bfcache restore.
        window.addEventListener('pageshow', (e) => {
            if (!e.persisted) return;
            $$('.loading').forEach(el => el.classList.remove('loading'));
        });
    }

};

// A/B Test(s) Manager ... if any.
Object.assign(window.HiSnaps, {
    
    // Disabled our manual popup in favor of the new Klaviyo version.
    /*
    abTest: {
        storageKey: "snap.abTest.variant",
        trackingKey: "snap.abTest.tracked",
        
        init() {
            const variant = this.getVariant();
            this.setCartAttribute(variant);
            this.trackVisitor(variant);
            return variant;
        },

        // Getters + Setters
        getVariant() {
            let variant = localStorage.getItem(this.storageKey);
            if (!variant) {
                variant = Math.random() < 0.5 ? 'control' : 'discount10';
                localStorage.setItem(this.storageKey, variant);
                console.log(`User Variant → ${variant}.`);
            }
            return variant;
        },
        async setCartAttribute(variant) {
            try {
                await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        attributes: {
                            '_ab_popup_test': variant
                        }
                    })
                });
                console.log(`Cart Variant → ${variant}`);
            } catch (error) {
                console.error('Cart Variant → Failed to set.', error);
            }
        },

        // Unique Visitors
        async trackVisitor(variant) {
            if (localStorage.getItem(this.trackingKey)) return;
            localStorage.setItem(this.trackingKey, 'true');
            
            const klaviyoKey = HiSnaps.email?.klaviyoKey;
            if (!klaviyoKey) return;
            
            try {
                await fetch(`https://a.klaviyo.com/client/events/?company_id=${klaviyoKey}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'revision': '2025-10-15'
                    },
                    body: JSON.stringify({
                        data: {
                            type: 'event',
                            attributes: {
                                properties: {
                                    variant: variant,
                                    page_url: window.location.href
                                },
                                metric: {
                                    data: {
                                        type: 'metric',
                                        attributes: {
                                            name: 'Discount Modal AB Test'
                                        }
                                    }
                                }
                            }
                        }
                    })
                });
                console.log(`Visitor → ${variant}`);
            } catch (error) {
                console.error('Visitor → Failed to track.', error);
            }
        },
    }
    */

});